import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { matchPath, Link } from "react-router-dom";
import {
  CONVERSION_STATE_KEY_DONE,
  CONVERSION_STATE_KEY_FAILED,
} from "../../../constants/conversion_states";
import { If } from "react-extras";
import Spinner from "../../lib/spinner";
import EpisodeImage from "./episode_image";
import "./episodes.scss";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import MediaFileProgressBar from "./media_file_progress_bar";
import ExpandableText from "../../lib/expandable_text/expandable_text";
import ContextMenu from "../../lib/context_menu";
import { formatDuration } from "../../../lib/duration";
import { formatPublishDate } from "../../../lib/publish_date";
import MediaPlayer from "../../lib/media_player/media_player";
import { createTitle } from "../../../lib/strings";
import { Helmet } from "react-helmet";
import { getMegapodURL } from "../../../lib/config";
import Moment from "moment";
import ExternalLink from "../../lib/external_link";
import Badge from "../../lib/badge";
import Divider from "../../lib/divider";
import ClipboardAction from "../../lib/clipboard-action";
import { ShowPageNav } from "../../lib/show_page_nav/show_page_nav";
import StatsWidgetContainerWrapper from "../../lib/stats/stats_widget_container_wrapper";
import WarningPanel from "../../lib/warning_panel";
import { newUUID } from "../../../lib/uuid";
import InfoTooltip from "../../lib/info";

class EpisodePage extends Component {
  constructor(props) {
    super(props);
    this.getShowUUID = this.getShowUUID.bind(this);
    this.getEpisodeUUID = this.getEpisodeUUID.bind(this);
  }
  state = {
    currentTime: 0,
    refreshToken: newUUID(),
  };
  componentDidMount() {
    var showUUID = this.getShowUUID();
    var episodeUUID = this.getEpisodeUUID();
    this.props.getEpisode(episodeUUID);

    if (showUUID && episodeUUID) {
      this.props.fetchShow(showUUID, this.props.user);
      this.props.getEpisode(episodeUUID).then(resp => {
        if (resp.status === 200) {
          const episode = resp.json;
          if (get(episode, "youTubeInfo.scheduledJobUUID")) {
            this.props.getScheduledJob(get(episode, "youTubeInfo.scheduledJobUUID"));
          }
          this.props.fetchMediaFile(resp.json.contentMediaFileUUID).then(resp => {
            if (resp.status === 200) {
              if (this.shouldPoll(resp.json)) {
                this.setCurrentTime();
                this.beginPolling();
              }
            }
          });
        }
      });
    }
  }

  shouldPoll = mediaFile => {
    const { conversionState, waveformURL } = mediaFile;
    return this.shouldRenderProgressBar(conversionState) || !waveformURL;
  };
  beginPolling = () => {
    this.timer = setInterval(() => {
      const { contentMediaFileUUID } = this.getEntities();
      this.setCurrentTime();
      this.props.fetchMediaFile(contentMediaFileUUID).then(resp => {
        if (resp.status === 200) {
          if (!this.shouldPoll(resp.json)) {
            this.endPolling();
          }
        }
      });
    }, 3000);
  };

  setCurrentTime = () => {
    this.setState({ currentTime: new Date().valueOf() / 1000 });
  };

  componentWillUnmount() {
    this.endPolling();
  }

  endPolling() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  getEntities = () => {
    var showUUID = this.getShowUUID();
    var episodeUUID = this.getEpisodeUUID();

    var episode = get(this.props, ["episodes", "episodeByUUID", episodeUUID]);
    var show = get(this.props.shows, ["shows", showUUID], {});
    var isLoading = get(episode, "isLoading") || get(this.props.shows, "isLoading");

    var imageMediaFileUUID;
    if (get(episode, "imageMediaFileUUID")) {
      imageMediaFileUUID = episode.imageMediaFileUUID;
    } else {
      imageMediaFileUUID = get(show, "imageMediaFileUUID");
    }
    var contentMediaFileUUID = get(episode, "contentMediaFileUUID");
    var contentMediaFile = contentMediaFileUUID && this.props.mediaFiles[contentMediaFileUUID];
    var conversionState = get(contentMediaFile, "conversionState");

    return {
      episode,
      show,
      imageMediaFileUUID,
      contentMediaFileUUID,
      conversionState,
      contentMediaFile,
      isLoading,
    };
  };

  shouldRenderProgressBar = conversionState => {
    return (
      conversionState &&
      conversionState !== CONVERSION_STATE_KEY_DONE &&
      conversionState !== CONVERSION_STATE_KEY_FAILED
    );
  };

  youtubeNav = () => {
    if (!this.getEntities().episode.isVisible) {
      return null;
    }
    const youtubeInfo = get(this.getEntities(), "episode.youTubeInfo");
    if (!get(this.getEntities(), "show.youtubeAuthToken.accessToken")) {
      return null;
    }
    const scheduledJob = get(this.props.scheduledJobs, get(youtubeInfo, "scheduledJobUUID"));
    if (get(youtubeInfo, "videoID")) {
      return (
        <ShowPageNav
          fullWidth
          noMinHeight
          component={ExternalLink}
          title={"YouTube Video"}
          onClick={() =>
            window.open(`https://www.youtube.com/watch?v=${get(youtubeInfo, "videoID")}`, "_blank")
          }
        />
      );
    }
    if (get(youtubeInfo, "scheduledJobUUID")) {
      if (!get(scheduledJob, "error")) {
        return (
          <ShowPageNav
            disabled
            fullWidth
            noMinHeight
            tooltip={"Your video is processing. Please check back in a few hours."}
            component={ExternalLink}
            title={"YouTube Video"}
          />
        );
      }

      return (
        <div>
          <ShowPageNav
            fullWidth
            noMinHeight
            component={"div"}
            title={"YouTube Video"}
            className={"margin-bottom--large"}
            onClick={() => {
              this.props.publishToYoutubeConfirmation(() => {
                this.props.uploadToYoutube(this.getEpisodeUUID());
              });
            }}
          />

          <Col xs={12} md={12}>
            <WarningPanel isError>
              There was an error uploading your video. Please contact support.
            </WarningPanel>
          </Col>
        </div>
      );
    }

    return (
      <ShowPageNav
        fullWidth
        noMinHeight
        component={"div"}
        title={"Publish To YouTube"}
        onClick={() => {
          this.props.publishToYoutubeConfirmation(() => {
            this.props.uploadToYoutube(this.getEpisodeUUID());
          });
        }}
      />
    );
  };

  render() {
    var {
      episode,
      isLoading,
      imageMediaFileUUID,
      contentMediaFile,
      conversionState,
    } = this.getEntities();
    const episodeTitle = get(episode, "title");
    const show = this.getShow();
    const episodePublic =
      show &&
      (isEmpty(show.importedURL) || show.redirectVerified === true) &&
      Moment.unix(get(episode, "publishedAt")).isBefore(Moment());
    const publicLink = (
      <div className="show-page__additional-fields__web-player">
        <ExternalLink
          href={`${getMegapodURL()}shows/${this.getShowUUID()}/episodes/${this.getEpisodeUUID()}`}>
          Public Episode Page
        </ExternalLink>
      </div>
    );

    return (
      <div className="episode-page-content page-wrapper">
        <Helmet>
          <title>{createTitle(episodeTitle)}</title>
        </Helmet>
        <Spinner isLoading={isLoading} />
        {episode && !isLoading && (
          <Grid fluid>
            <Row>
              <Col xs={12} md={12}>
                <div className="episode-page__back-link seedcast-back-link">
                  <Link to={"/shows/" + this.getShowUUID() + "/ep"} className="redcircle-big-link">
                    <span className="glyphicon glyphicon-chevron-left back-link-chevron" />
                    Back
                  </Link>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <MediaFileProgressBar
                  mediaFileUUID={episode.contentMediaFileUUID}
                  mediaFiles={this.props.mediaFiles}
                  fetchMediaFile={this.props.fetchMediaFile}
                  user={this.props.user}
                  shouldRender={this.shouldRenderProgressBar(conversionState)}
                  delayClose={5000}
                  episodeTitle={episode.title}
                  currentTime={this.state.currentTime}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <div className="episode-page-image-container">
                  <EpisodeImage
                    imageMediaFileUUID={imageMediaFileUUID}
                    user={this.props.user}
                    mediaFiles={this.props.mediaFiles}
                    className="episode-page-image rounded-image"
                    fetchImage={this.props.fetchMediaFile}
                  />
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div className="episode-page-main-info seedcast-main-info">
                  <div className="clearfix flex-row-container align-center">
                    <h1 className="episode-page__title">{episode.title}</h1>
                    <If condition={!episode.isVisible}>
                      <Badge text="DRAFT" />
                    </If>
                    <div className="flex-1" />
                    <ContextMenu
                      className="margin-top--small"
                      noCircle={true}
                      menuItems={{
                        "Edit Episode": () => {
                          this.props.history.push(
                            `/shows/${this.getShowUUID()}/ep/${episode.uuid}/edit`
                          );
                        },
                        "Copy Episode Media URL": () => {
                          new ClipboardAction({
                            text: episode.streamURL,
                            container: document.body,
                          });
                          this.props.showSuccess("URL Copied to Clipboard");
                        },
                        "Delete Episode": () => {
                          this.props.episodeDeleteModalReset();
                          this.props.showEpisodeDeleteModal(
                            this.getShowUUID(),
                            this.getEpisodeUUID()
                          );
                        },
                      }}
                    />
                  </div>
                  <Divider smallMargin />
                  <div className="episode-page-main-info__subtitle seedcast-main-info__subtitle limit-images">
                    <ExpandableText dangerousText={episode.description} heightToWidth={4} />
                  </div>
                  <div className="episode-page-main-info__additional-fields subtext">
                    <If
                      condition={contentMediaFile && conversionState === CONVERSION_STATE_KEY_DONE}>
                      <If condition={episodePublic}>{publicLink}</If>

                      <div className="episode-page-main-info__additional-fields__duration">
                        {formatDuration(get(contentMediaFile, "duration"))}
                      </div>
                    </If>
                    <div className="episode-page-main-info__additional-fields__duration">
                      {formatPublishDate(episode.publishedAt, episode.isVisible)}
                    </div>
                  </div>
                </div>
                <div className="episode-page__media-player flex-row-container align-center">
                  <div className={"flex-1 margin-right--small"}>
                    <MediaPlayer
                      mediaFileURL={`${episode.streamURL}?forceRefreshToken=${this.state.refreshToken}`}
                    />
                  </div>
                  <div>
                    <button
                      className={
                        "btn btn-secondary btn-small margin-bottom--none margin-left--small"
                      }
                      onClick={() => this.setState({ refreshToken: newUUID() })}>
                      Refresh
                    </button>
                    <InfoTooltip
                      helpText="Click refresh to listen to the latest version that has any updates to insertion
                    points and audio blocks"
                    />
                  </div>
                </div>
                <Row>
                  <ShowPageNav
                    fullWidth
                    noMinHeight
                    title={"Embed This Episode"}
                    to={`/shows/${this.getShowUUID()}/ep/${this.getEpisodeUUID()}/embed`}
                  />
                </Row>
                <Row>
                  <ShowPageNav
                    fullWidth
                    noMinHeight
                    title={"Insertion Points"}
                    to={`/shows/${this.getShowUUID()}/ep/${this.getEpisodeUUID()}/insertion-points`}
                  />
                </Row>
                <Row>
                  <ShowPageNav
                    fullWidth
                    noMinHeight
                    title={"Analytics"}
                    to={`/stats?showUUID=${this.getShowUUID()}&episodeUUID=${this.getEpisodeUUID()}`}
                  />
                </Row>
                <Row>{this.youtubeNav()}</Row>
              </Col>
            </Row>
            <StatsWidgetContainerWrapper uuid={this.getEpisodeUUID()} uuidType={"episodeUUID"} />
          </Grid>
        )}
      </div>
    );
  }

  getShow = () => {
    return get(this.props.shows.shows, this.getShowUUID());
  };

  getShowUUID() {
    var result = matchPath(this.props.location.pathname, "/shows/:showUUID/ep/:episodeUUID");
    return result && result.params && result.params.showUUID;
  }

  getEpisodeUUID() {
    var result = matchPath(this.props.location.pathname, "/shows/:showUUID/ep/:episodeUUID");
    return result && result.params && result.params.episodeUUID;
  }
}

export default EpisodePage;
